import { useLang } from "../i18n";

export default function Marquee() {
  const { t } = useLang();
  const items = t("marquee");
  const row = [...items, ...items, ...items];

  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 bg-[#0D0F16] py-5">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-8 pr-8 font-display text-sm font-semibold tracking-[0.3em] text-slate-500">
                {item}
                <span className="text-[#4499F7] text-xs">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
